module.exports = __webpack_public_path__ + "static/media/star_dashboard.2e1287f9.svg";